/* eslint-disable unicorn/prefer-global-this */
// ✅ React
import React from "react";

// ✅ Ant Design Components
import {
  Popconfirm,
  Button,
  Popover,
  Menu,
  Dropdown,
  notification,
} from "antd";
import {
  LoadingOutlined,
  EditOutlined,
  ExclamationCircleFilled,
} from "@ant-design/icons";

// ✅ Third-party Libraries
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faPrint } from "@fortawesome/free-solid-svg-icons";

// ✅ Custom UI Components
import H3Text from "@Uilib/h3Text";
import H3FormInput from "@Uilib/h3FormInput";
import H3Image from "../../../../../uilib/h3Image";

// ✅ Helpers
import Helpers from "../../../../../apis/helpers";
import { getMenu } from "../helper";

// ✅ Images / Icons
import ucIcon from "@Images/icons/unicommerce-icon.png";
import ShopifyIcon from "@Images/admin/integrations/shopify-icon.png";
import zohoIcon from "@Images/admin/integrations/zoho-books.png";
import TallyPrime from "@Images/admin/integrations/tally-prime.png";
import Crown from "@Images/crown2.png";

function ViewCreditNoteHeader({
  currentCN,
  syncSOLoading,
  syncSO,
  user,
  isReturnSlip,
  history,
  updateCNStatusLoading,
  currentUpdate,
  setCurrentUpdate,
  setSendForApprovalConfirmation,
  cancellationReason,
  setCancellationReason,
  cancellationPop,
  setCancellationPop,
  getCNById,
  downloadDocument,
  selectedCNId,
  updateCNStatus,
  callback,
  showTriggerNode,
  deleteCN,
  deleteCNLoading,
  syncShopifySO,
  syncShopifySOLoading,
  syncCN,
  syncCNLoading,
  setShowEWaybillFormDrawer,
  pushCreditNoteToBusy,
  pushCreditNoteToBusyLoading,
  setShowPayment,
  setLinkPayment,
  isTallyConnected,
  syncTallyInvoice,
  getCNByIdLoading,
  syncTallyInvoiceLoading
}) {
  return (
    <div className="view-document__title">
      <div className="view-document__title-number-wrapper">
        <H3Text
          text={currentCN?.credit_note_number}
          className="view-document__title-number"
        />
        <div
          className="view-document__title-status"
          style={{
            backgroundColor: Helpers.getStatusColor(currentCN?.status)
              .color,
          }}
        >
          {currentCN?.status?.replaceAll("_", " ")}
        </div>
      </div>
      <div className="view-document__title-actions">
        <div className="action-buttons">
          {currentCN?.unicommerce_so_code && (
            <div className="action-buttons">
              <H3Text
                text={
                  <div
                    onClick={() => {
                      if (!syncSOLoading) {
                        syncSO(
                          {
                            tenant_id: currentCN?.tenant_id,
                            unicommerce_so_codes: [
                              currentCN?.unicommerce_so_code,
                            ],
                          },
                          () => {
                            getCNById(
                              Helpers.getTenantEntityPermission(
                                user?.user_tenants,
                                Helpers.permissionEntities
                                  .CREDIT_NOTE,
                                Helpers.permissionTypes.READ
                              ).join(",") ||
                              user?.tenant_info?.tenant_id,
                              currentCN.cn_id
                            );
                          }
                        );
                      }
                    }}
                  >
                    <div className="unicommerce-icon-so">
                      <img alt="unicommerce" src={ucIcon} />
                      {syncSOLoading ? <LoadingOutlined /> : "Sync"}
                    </div>
                  </div>
                }
                className="action-button action-button-big"
              />
            </div>
          )}
          {(isReturnSlip
            ? Helpers.getPermission(
              Helpers.permissionEntities.RETURN_SLIP,
              Helpers.permissionTypes.UPDATE,
              user
            )
            : Helpers.getPermission(
              Helpers.permissionEntities.CREDIT_NOTE,
              Helpers.permissionTypes.UPDATE,
              user
            )) &&
            !currentCN?.unicommerce_so_code &&
            !["VOID", "CONFIRMED"].includes(
              currentCN?.status?.toUpperCase()
            ) && (
            <H3Text
              text={
                <div
                  onClick={() => {
                    if (isReturnSlip) {
                      history.push(
                          `/sales/return-slip/update/${currentCN?.cn_id}`
                      );
                    } else {
                      history.push(
                          `/sales/credit-notes/update/${currentCN?.cn_id}`
                      );
                    }
                  }}
                >
                  <EditOutlined />
                </div>
              }
              className="action-button hide__in-mobile"
            />
          )}
          <Dropdown
            overlay={getMenu({
              currentCN,
              isReturnSlip,
              downloadDocument,
            })}
            trigger={["click"]}
          >
            <div
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "40px",
              }}
              className="action-button"
            >
              <FontAwesomeIcon
                icon={faPrint}
                style={{ fontSize: "16px" }}
              />
            </div>
          </Dropdown>
        </div>
        {!currentCN?.unicommerce_so_code && (
          <div className="action-buttons">
            {["DRAFT"].includes(currentCN?.status) &&
              Helpers.getPermission(
                Helpers.permissionEntities.CREDIT_NOTE,
                Helpers.permissionTypes.UPDATE,
                user
              ) && (
              <Popconfirm
                placement="topRight"
                title={`Are you sure you want to send this ${isReturnSlip ? "return slip" : "credit note"
                    } for approval?`}
                onConfirm={() => {
                  setCurrentUpdate("SENT_FOR_APPROVAL");

                  updateCNStatus(
                    {
                      status: "SENT_FOR_APPROVAL",
                      cn_id: currentCN.cn_id,
                      doc_type: currentCN?.doc_type,
                    },
                    () => {
                      setCurrentUpdate("");
                      setSendForApprovalConfirmation(false);
                      if (selectedCNId) {
                        callback();
                      } else {
                        getCNById(
                          Helpers.getTenantEntityPermission(
                            user?.user_tenants,
                            Helpers.permissionEntities.CREDIT_NOTE,
                            Helpers.permissionTypes.READ
                          ).join(",") ||
                            user?.tenant_info?.tenant_id,
                          currentCN.cn_id,
                          currentCN?.doc_type
                        );
                      }
                    }
                  );
                }}
                okText="Yes"
                cancelText="No"
              >
                <H3Text
                  text={
                    <div
                      style={{
                        width: "130px",
                        textAlign: "center",
                      }}
                    >
                      {updateCNStatusLoading &&
                          currentUpdate === "SENT_FOR_APPROVAL" ? (
                          <LoadingOutlined />
                        ) : (
                          <span>
                            {isReturnSlip
                              ? "Confirm Return Slip"
                              : " Confirm Credit Note"}
                          </span>
                        )}
                    </div>
                  }
                  onClick={() =>
                    setSendForApprovalConfirmation(true)
                  }
                  className="action-button action-button-big"
                />
              </Popconfirm>
            )}
            {currentCN?.status?.toLowerCase() !== "void" &&
              Helpers.getPermission(
                Helpers.permissionEntities.CREDIT_NOTE,
                Helpers.permissionTypes.UPDATE,
                user
              ) && (
              <Popover
                placement="topRight"
                title="Are you sure you want to cancel?"
                open={cancellationPop}
                content={
                  <React.Fragment>
                    {" "}
                    <H3FormInput
                      name="field name"
                      type="text"
                      containerClassName="orgInputContainer create__right-input"
                      labelClassName="orgFormLabel"
                      inputClassName="orgFormInput"
                      placeholder=""
                      onChange={(event) =>
                        setCancellationReason(event.target.value)
                      }
                      value={cancellationReason}
                      label="Reason"
                      maxlength="100"
                      required
                      showError={
                        currentUpdate === "VOID" &&
                          !cancellationReason
                      }
                    />
                    <div className="view-document__cancellation-buttons">
                      <Button
                        type=""
                        size="small"
                        onClick={() => {
                          setCancellationPop(false);
                        }}
                      >
                          No
                      </Button>
                      <Button
                        onClick={() => {
                          setCurrentUpdate("VOID");
                          if (cancellationReason) {
                            if (
                              currentCN?.e_invoice_status ===
                                "PUSHED"
                            ) {
                              notification.open({
                                message:
                                    "Please cancel the e-Invoice first",
                                type: "error",
                                placement: "top",
                                duration: 4,
                              });
                            } else {
                              updateCNStatus(
                                {
                                  status: "VOID",
                                  cn_id: currentCN.cn_id,
                                  cancellation_reason:
                                      cancellationReason,
                                  doc_type: currentCN?.doc_type,
                                },
                                () => {
                                  setCurrentUpdate("");
                                  setCancellationPop(false);
                                  if (selectedCNId) {
                                    callback();
                                  } else {
                                    getCNById(
                                      Helpers.getTenantEntityPermission(
                                        user?.user_tenants,
                                        Helpers.permissionEntities
                                          .CREDIT_NOTE,
                                        Helpers.permissionTypes.READ
                                      ).join(",") ||
                                        user?.tenant_info
                                          ?.tenant_id,
                                      currentCN.cn_id,
                                      currentCN?.doc_type
                                    );
                                  }
                                }
                              );
                            }
                          }
                        }}
                        type="primary"
                        size="small"
                      >
                          Yes
                      </Button>
                    </div>
                  </React.Fragment>
                }
                trigger="click"
              >
                <H3Text
                  text={
                    <div
                      style={{ width: "50px", textAlign: "center" }}
                    >
                      {updateCNStatusLoading &&
                          currentUpdate === "VOID" ? (
                          <LoadingOutlined />
                        ) : (
                          <span>Cancel</span>
                        )}
                    </div>
                  }
                  onClick={() => {
                    setCancellationPop(true);
                  }}
                  className="action-button action-button-big"
                />
              </Popover>
            )}

            {Helpers.getPermission(
              isReturnSlip
                ? Helpers.permissionEntities.RETURN_SLIP
                : Helpers.permissionEntities.CREDIT_NOTE,
              Helpers.permissionTypes.DELETE,
              user
            ) && (
              <Popconfirm
                placement="topRight"
                title={`Are you sure you want to delete the ${isReturnSlip ? "return slip" : "credit note"
                    }?`}
                onConfirm={() => {
                  deleteCN(
                    {
                      tenant_id: currentCN?.tenant_id,
                      cn_id: currentCN.cn_id,
                      doc_type: currentCN?.doc_type,
                    },
                    () => {
                      if (selectedCNId) {
                        callback();
                      } else {
                        if (isReturnSlip) {
                          history.push("/sales/return-slips");
                        } else {
                          history.push("/sales/credit-notes");
                        }
                      }
                    }
                  );
                }}
                okText="Yes"
                cancelText="No"
              >
                <H3Text
                  text={
                    <div>
                      {deleteCNLoading ? (
                        <LoadingOutlined />
                      ) : (
                        <span>Delete</span>
                      )}
                    </div>
                  }
                  className="action-button action-button-big"
                />
              </Popconfirm>
            )}
            {["ISSUED"].includes(currentCN?.status) && !isReturnSlip && (
              <H3Text
                className="action-button action-button-big"
                onClick={() => {
                  if (!syncShopifySOLoading) {
                    syncShopifySO(
                      {
                        shopify_order_id: currentCN?.shopify_order_id,
                      },
                      () => {
                        getCNById(
                          Helpers.getTenantEntityPermission(
                            user?.user_tenants,
                            Helpers.permissionEntities.CREDIT_NOTE,
                            Helpers.permissionTypes.READ
                          ).join(",") || user?.tenant_info?.tenant_id,
                          currentCN.cn_id
                        );
                      }
                    );
                  }
                }}
                text={
                  <React.Fragment>
                    {syncShopifySOLoading ? (
                      <LoadingOutlined />
                    ) : (
                      <React.Fragment>
                        <H3Image
                          src={ShopifyIcon}
                          className="action-menu-shopify-icon"
                        />
                        <H3Text
                          text="Sync"
                          className="action-menu-button"
                        />
                      </React.Fragment>
                    )}
                  </React.Fragment>
                }
              />
            )}
            {!["DRAFT", "VOID", "REJECTED", "CANCELLED"].includes(
              currentCN?.status
            ) && !isReturnSlip &&
              user?.user_tenants?.find(
                (item) => item?.tenant_id === currentCN?.tenant_id
              )?.zoho_branch_id &&
              currentCN?.invoice_id && (
              <div
                style={{ width: "80px" }}
                className="action-button action-button-big"
                onClick={() => {
                  if (!syncCNLoading) {
                    syncCN({ cn_id: currentCN?.cn_id }, () => {
                      getCNById(
                        Helpers.getTenantEntityPermission(
                          user?.user_tenants,
                          Helpers.permissionEntities.CREDIT_NOTE,
                          Helpers.permissionTypes.READ
                        ).join(",") || user?.tenant_info?.tenant_id,
                        currentCN.cn_id
                      );
                    });
                  }
                }}
              >
                {syncCNLoading ? (
                  <LoadingOutlined />
                ) : (
                  <React.Fragment>
                    <H3Image
                      src={zohoIcon}
                      className="action-menu-zoho-icon"
                    />
                    <H3Text
                      text="Sync"
                      className="action-menu-button"
                    />
                  </React.Fragment>
                )}
              </div>
            )}
            {currentCN?.status === "CONFIRMED" && !isReturnSlip && (
              <Dropdown
                {...(showTriggerNode
                  ? {
                    getPopupContainer: (triggerNode) =>
                      triggerNode.parentNode,
                  }
                  : {})}
                overlay={
                  <div style={{ width: "183px" }}>
                    <Menu>
                      {Helpers.getPermission(
                        Helpers.permissionEntities.E_WAY_BILL,
                        Helpers.permissionTypes.UPDATE,
                        user
                      ) &&
                        !currentCN?.e_way_bills?.filter(
                          (rec) => rec?.status === "GENERATED"
                        )?.length &&
                        user?.tenant_info?.sales_config?.addons
                          ?.e_waybill?.is_active && (
                        <Menu.Item>
                          <H3Text
                            text={
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <div>+ e-Way Bill</div>
                                {!user?.tenant_info?.sales_config
                                  ?.addons?.e_waybill
                                  ?.is_active && (
                                  <Popconfirm
                                    placement="topRight"
                                    title="This feature is not accessible within your current plan to use this feature contact us."
                                    onConfirm={() =>
                                      window.Intercom(
                                        "showNewMessage"
                                      )
                                    }
                                    okText="Contact Us"
                                    cancelText="Cancel"
                                  >
                                    <img
                                      className="barcode-restrict"
                                      style={{ marginLeft: "4px" }}
                                      src={Crown}
                                      alt="premium"
                                    />
                                  </Popconfirm>
                                )}
                              </div>
                            }
                            onClick={() =>
                              setShowEWaybillFormDrawer(true)
                            }
                            className="hide__in-mobile"
                          />
                        </Menu.Item>
                      )}
                      {Helpers.getPermission(
                        Helpers.permissionEntities.CUSTOMER_PAYMENTS,
                        Helpers.permissionTypes.CREATE,
                        user
                      ) && (
                        <Menu.Item>
                          <H3Text
                            text={
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <div>Record Payment</div>
                                {!user?.tenant_info?.sales_config
                                  ?.sub_modules?.payment_incoming
                                  ?.is_active && (
                                  <Popconfirm
                                    placement="topRight"
                                    title="This feature is not accessible within your current plan to use this feature contact us."
                                    onConfirm={() =>
                                      window.Intercom(
                                        "showNewMessage"
                                      )
                                    }
                                    okText="Contact Us"
                                    cancelText="Cancel"
                                  >
                                    <img
                                      className="barcode-restrict"
                                      style={{ marginLeft: "4px" }}
                                      src={Crown}
                                      alt="premium"
                                    />
                                  </Popconfirm>
                                )}
                              </div>
                            }
                            onClick={() => {
                              if (
                                user?.tenant_info?.sales_config
                                  ?.sub_modules?.payment_incoming
                                  ?.is_active
                              ) {
                                setShowPayment(true);
                              }
                            }}
                            className="hide__in-mobile"
                          />
                        </Menu.Item>
                      )}
                      {Helpers.getPermission(
                        Helpers.permissionEntities.CUSTOMER_PAYMENTS,
                        Helpers.permissionTypes.CREATE,
                        user
                      ) &&
                        window.screen.width > 425 && (
                        <Menu.Item>
                          <H3Text
                            text={
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <div>Link Payment</div>
                                {!user?.tenant_info?.sales_config
                                  ?.sub_modules?.payment_incoming
                                  ?.is_active && (
                                  <Popconfirm
                                    placement="topRight"
                                    title="This feature is not accessible within your current plan to use this feature contact us."
                                    onConfirm={() =>
                                      window.Intercom(
                                        "showNewMessage"
                                      )
                                    }
                                    okText="Contact Us"
                                    cancelText="Cancel"
                                  >
                                    <img
                                      className="barcode-restrict"
                                      style={{ marginLeft: "4px" }}
                                      src={Crown}
                                      alt="premium"
                                    />
                                  </Popconfirm>
                                )}
                              </div>
                            }
                            onClick={() => {
                              if (
                                user?.tenant_info?.sales_config
                                  ?.sub_modules?.payment_incoming
                                  ?.is_active
                              ) {
                                setLinkPayment(true);
                              }
                            }}
                            className="hide__in-mobile"
                          />
                        </Menu.Item>
                      )}
                      {isTallyConnected && (
                        <Menu.Item>
                          <Popconfirm
                            placement="topRight"
                            title={
                              currentCN?.tally_warning_message ?? (currentCN?.tally_updated_at
                                ? " Credit Note is already synced with tally"
                                : " Credit Note is not synced with tally")
                            }
                            onConfirm={() =>
                              syncTallyInvoice(
                                {
                                  cn_id: currentCN?.cn_id,
                                  override_creation: false,
                                },
                                () => {
                                  getCNById(
                                    Helpers.getTenantEntityPermission(
                                      user?.user_tenants,
                                      Helpers.permissionEntities
                                        .CREDIT_NOTE,
                                      Helpers.permissionTypes.READ
                                    ).join(",") ||
                                    user?.tenant_info?.tenant_id,
                                    currentCN.cn_id
                                  );
                                }
                              )
                            }
                            okText={
                              !currentCN?.tally_warning_message &&
                                !currentCN?.tally_updated_at
                                ? "Sync"
                                : "Sync Again"
                            }
                            okButtonProps={{
                              loading:
                                syncTallyInvoiceLoading ||
                                getCNByIdLoading,
                            }}
                            cancelText="Cancel"
                            icon={
                              currentCN?.tally_warning_message ? (
                                <ExclamationCircleFilled
                                  style={{ color: "#F2BD27" }}
                                />
                              ) : (
                                <React.Fragment />
                              )
                            }
                          >
                            <div
                              className="action-button action-button-big action-button-tally"
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <img
                                src={TallyPrime}
                                alt="Tally"
                                className="action-menu-zoho-icon"
                              />
                              <H3Text
                                text="Sync"
                                className="action-menu-button"
                              />
                            </div>
                          </Popconfirm>
                        </Menu.Item>
                      )}
                    </Menu>
                  </div>
                }
                trigger={["click"]}
                overlayStyle={{ width: "90px" }}
                placement="topRight"
              >
                <div
                  className="action-button action-button-big"
                  onClick={(e) => e.preventDefault()}
                >
                  More &nbsp;
                  <FontAwesomeIcon icon={faCaretDown} />
                </div>
              </Dropdown>
            )}
            {currentCN?.integration_busy_config?.status ===
              "CONNECTED" &&
              ["CONFIRMED"].includes(currentCN?.status) &&
              !isReturnSlip && (
              <H3Text
                text={
                  pushCreditNoteToBusyLoading ? (
                    <LoadingOutlined />
                  ) : (
                    "Push To Busy"
                  )
                }
                className="action-button action-button-big"
                onClick={() =>
                  pushCreditNoteToBusy(
                    { cn_id: currentCN?.cn_id },
                    () =>
                      getCNById(
                        Helpers.getTenantEntityPermission(
                          user?.user_tenants,
                          Helpers.permissionEntities.CREDIT_NOTE,
                          Helpers.permissionTypes.READ
                        ).join(",") || user?.tenant_info?.tenant_id,
                        currentCN.cn_id
                      )
                  )
                }
              />
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default ViewCreditNoteHeader;